// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import {
  PlayerAttributesRow,
  PlayerMetadataRow,
} from "@suns/api/generated-client/apollo";
import { cn, Flex, Grid, Text } from "@suns/design-system";
import { Check, X } from "@suns/design-system/icons";

export default function PlayerAttributes({
  playerMetadata,
  print = false,
}: {
  playerMetadata: PlayerMetadataRow;
  print?: boolean;
}) {
  const attributesList = playerMetadata?.attributes ?? [];

  if (!attributesList.length) {
    return null;
  }

  const attributeValues = attributesList.reduce<
    Record<PlayerAttributesRow.key, boolean>
  >(
    (acc, { key, value }) => {
      acc[key] = value;
      return acc;
    },
    {} as Record<PlayerAttributesRow.key, boolean>
  );

  const attributes = [
    {
      label: "Physically Tough",
      checked: attributeValues[PlayerAttributesRow.key.PHYSICALLY_TOUGH],
    },
    {
      label: "Plays Hard",
      checked: attributeValues[PlayerAttributesRow.key.PLAYS_HARD],
    },
    {
      label: "Gets Extra Possessions",
      checked: attributeValues[PlayerAttributesRow.key.GETS_EXTRA_POSSESSIONS],
    },
    {
      label: "Positive Energy",
      checked: attributeValues[PlayerAttributesRow.key.POSITIVE_ENERGY],
    },
    {
      label: "Communicates",
      checked: attributeValues[PlayerAttributesRow.key.COMMUNICATES],
    },
    {
      label: "Plays with Passion and Emotions",
      checked:
        attributeValues[
          PlayerAttributesRow.key.PLAYS_WITH_PASSION_AND_EMOTIONS
        ],
    },
    {
      label: "Team First Mindset",
      checked: attributeValues[PlayerAttributesRow.key.TEAM_FIRST_MINDSET],
    },
    {
      label: "Improvement Driven",
      checked: attributeValues[PlayerAttributesRow.key.IMPROVEMENT_DRIVEN],
    },
    {
      label: "Impacts Winning",
      checked: attributeValues[PlayerAttributesRow.key.IMPACTS_WINNING],
    },
  ];

  return (
    <Flex direction="down" gap="md">
      <Text heading muted size="md">
        Suns DNA
      </Text>
      <Grid columns={print ? ["3"] : ["2", "lg:3"]} gap="sm">
        {attributes.map((attribute) => (
          <Flex key={attribute.label} direction="right" gap="xs" align="center">
            {attribute.checked ? (
              <Check className="size-5 text-secondary" />
            ) : (
              <X className="size-5 text-red-500" />
            )}
            <Text
              size="xs"
              heading
              className={cn(attribute.checked ? "text-black" : "text-gray-500")}
            >
              {attribute.label}
            </Text>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
}
